/*
  This lets you have two active components with only one visible.
  It will fill the full height and width of its parent.
  It just needs to know if the second ("b") component is visible
  and handles the rest.

  NOTE: It does not slide, lol. MJ gave up after CSS had a very
  hard time with relative positioning.
*/

import React from 'react';

import styles from './SectionSlider.scss';

const SectionSlider = ({ a, b, activeSection }) => {
  return (
    <div className={`SectionSlider`}>
      <div
        className={`SectionSlider__a${
          activeSection === 'a' ? ' is-active' : ''
        }`}
      >
        {a}
      </div>
      <div
        className={`SectionSlider__b${
          activeSection === 'b' ? ' is-active' : ''
        }`}
      >
        {b}
      </div>
    </div>
  );
};

export default SectionSlider;
